import React, { useState } from "react";
import flag from "../../src/assets/rpm/flaginfocard.svg";
import comment from "../../src/assets/rpm/msginfo.svg";
import add from "../../src/assets/rpm/addnoteinfo.svg";
import edit from "../../src/assets/rpm/editinfocard.svg";
import { fullformatTimestamp } from "../utils/dateutils/dateutility";
import useStore from "../store/zustandstore";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import RpmLineChart from "./tabs/rpmlinegraph";
import Infograph from "./tabs/Infograph";
import TabsComponent from "./tabs";
import Infographtab from "./infographtab";
import dayjs from "dayjs";
import { chatIcon, fileIcon, flagIcon, penIcon } from "./tabs/svg";
import { patientPhotoUrl } from "../config/practice";

const InfoCard = ({
  data,
  setRpmCard,
  setNotesForm,
  setSelectedCard,
  setRiskmodal,
  setEditPatient,
  setChat,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const percentage = 100; // Set your percentage value here
  // Styles for the circular progress bar and small circle with percentage text
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };

  const angle = percentage * 3.6;
  const radians = (angle - 90) * (Math.PI / 180);
  const radius = 35;
  const smallCircleOffset = 8;

  const smallCircleStyle = {
    position: "absolute",
    top: `${50 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${50 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "22px",
    height: "22px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const handleComment = () => {
    setSelectedCard(data);
    setChat(true);
  };
  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => setShowAll((prev) => !prev);

  const deviceButtons =
    data?.device_mast?.slice(0, showAll ? undefined : 3) || [];

  const chartData =
    data?.BPP?.map((reading) => ({
      date: reading.datetime,
      systolic: reading.systolic,
      diastolic: reading.diastolic,
      pulse: reading.pulse,
    })) || [];

  const allTabs = ["BPP", "WLM", "CGM"];

  const tabs = allTabs
    .filter((label) => data?.[label]?.length > 0)
    .map((label) => ({ label }));

  const handleTabSelect = (index) => {
    setSelectedTab(index);
  };

  const renderGraph = () => {
    switch (selectedTab) {
      case 0: // BPP Tab
        return data?.BPP && data?.BPP.length > 0 ? (
          <div className="flex flex-col gap-0 ">
            <Infograph data={data?.BPP.slice(-4)} weightOnly={false} />
          </div>
        ) : (
          <div
            className="flex justify-center items-center  rounded-lg"
            style={{ height: "110px", width: "240px" }}
          >
            <span className="text-xs text-[#ccc]"></span>
          </div>
        );

      case 1: // WLM Tab
        return data?.WLM && data?.WLM.length > 0 ? (
          <div className="flex flex-col gap-0 ">
            <Infograph data={data?.WLM.slice(-4)} weightOnly={true} />
          </div>
        ) : (
          <div
            className="flex justify-center items-center rounded-lg"
            style={{ height: "110px", width: "240px" }}
          >
            <span className="text-xs text-[#ccc]"></span>
          </div>
        );

      case 2: // CGM Tab
        return data?.CGM && data?.CGM.length > 0 ? (
          <div className="flex flex-col gap-0 ">
            <Infograph data={data?.CGM.slice(-4)} />
          </div>
        ) : (
          <div
            className="flex justify-center items-center  rounded-lg"
            style={{ height: "110px", width: "240px" }}
          >
            <span className="text-xs text-[#ccc]"></span>
          </div>
        );

      default:
        return <div>No Data Found</div>;
    }
  };

  return (
    <div className="w-[95%] min-h-[150px] self-center  h-auto lg:ml-0 ml-2">
      <div
        className="w-[100%] min-w-[90%]  min-h-[150px]  h-auto rounded-[12px] p-3 flex-col sm:flex-row flex justify-between"
        style={{
          boxShadow: "0px 4px 9px 0px rgba(152, 160, 180, 0.25)",
          backgroundColor: "#FFF",
        }}
      >
        <div className="flex gap-11 ">
          <div className="flex flex-col">
            <div className="flex flex-col items-start  justify-start ml-4">
              <div className="relative flex justify-start items-center cursor-pointer" onClick={()=>{
    setSelectedCard(data)
    setRpmCard(true)}
  }>
                <img
                  src={patientPhotoUrl(data.patientid)}
                  alt="profile"
                  onError={(e) =>
                    (e.target.src =
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                  }
                  className="flex justify-center items-center w-[66px] h-[66px]  border-2 border-[pink] rounded-[14px]  "
                  style={{ border: `2px solid` }}
                />
              </div>
              {/* </div> */}
              <div className="flex flex-col gap-1 justify-start items-start mt-11">
                <div className=" text-sm font-semibold  text-left font-inter text-[#101828] ">{`${data?.firstname} ${data?.lastname}`}</div>
                <div className="text-[#6A7282] text-left text-sm font-font1">
                  #{data?.patientid}
                </div>
                <div className="text-[14px] text-left font-font1 font-normal text-[#6A7282] ">
                  {data?.subscription
                    ? (() => {
                        const formatted = data.subscription
                          .split(",")
                          .map(
                            (word) =>
                              word.trim().charAt(0).toUpperCase() +
                              word.trim().slice(1).toLowerCase()
                          )
                          .join(", ");

                        // Limit to 16 words
                        const words = formatted.split(/\s+/);
                        return words.length > 16
                          ? words.slice(0, 16).join(" ") + "..."
                          : formatted;
                      })()
                    : ""}
                </div>
                <div className=" text-[14px] text-left font-font1 font-normal text-[#6A7282] ">
                  DOB : {data?.dob}
                </div>
              </div>
            </div>
          </div>

          {/* secound section */}

          <div className="flex flex-col items-start text-start gap-y-2 font-semibold ">
            <div className="flex items-start flex-column gap-1 ">
              <div className=" text-[11px] text-[#09090B] text-start font-inter font-medium">
                BILLING
              </div>
              <div className="flex gap-2">
                <button className="bg-[#EFF6FF] text-[#09090B] text-[12px] px-2 rounded-full focus:outline-none border-[1px] border-[#E4E4E7]">
                  {
                    // Extract unique dates from the WLM array and show the count
                    (() => {
                      const uniqueDates = new Set(
                        (data?.BPP || []).map((item) => item.datetime.split(" ")[0]) // Get date part of 'datetime'
                      );
                      return uniqueDates.size; // Return the count of unique dates
                    })()
                  }{" "}
                  BPP
                </button>

                <button className="bg-[#F0FDF4] text-[#09090B] text-[12px] px-2 rounded-full focus:outline-none border-[1px] border-[#E4E4E7]">
                  {(() => {
                    const bppUniqueDates = new Set(
                      (data?.BPP || []).map((item) => item.datetime.split(" ")[0])
                    );
                    const wlmUniqueDates = new Set(
                      (data?.WLM || []).map((item) => item.datetime.split(" ")[0])
                    );
                    const combinedUniqueDates = new Set([
                      ...bppUniqueDates,
                      ...wlmUniqueDates,
                    ]);
                    return combinedUniqueDates.size;
                  })()}{" "}
                  Total
                </button>
                <button className="bg-[#FEF2F2] text-[#09090B] text-[12px] px-2 rounded-full focus:outline-none border-[1px] border-[#E4E4E7]">
                  {data?.tat} mins
                </button>
              </div>
            </div>
            <div className="flex gap-2 flex-column">
              <div className="text-[11px] text-[#09090B] text-start font-inter font-medium">
                STATUS{" "}
              </div>
              <div className="flex text-xs font-font1 font-semibold text-[#7E22CE] bg-[#FAF5FF] p-1 px-2 rounded-full">
                {data?.ts
                  ? `Enroll ${dayjs(data.signupdate).format("MM-DD-YYYY")}`
                  : ""}
              </div>

             <div className="text-xs font-font1 font-semibold text-[#1D4ED8] bg-[#EFF6FF] p-1 px-2 rounded-full">
  Authorize: {data?.authorize_on ? dayjs(data.authorize_on).format("MM-DD-YYYY") : "--"}
</div>

            </div>
            <div className="flex gap-3 items-center flex-column text-start mt-3">
              <div className="flex gap-0.5 flex-column">
                <div className=" text-[11px] text-[#09090B] font-medium font-inter">
                  LAST READING
                </div>
                <div className="font-normal text-[13px] text-[#6B7280]">
                  {fullformatTimestamp(data?.lastrefresh)}
                </div>
              </div>
              <div className="flex flex-column text-start gap-0.5 items-start  w-full">
                <div className="mr-1 text-[#09090B] text-xs font-medium font-font1">
                  DEVICE
                </div>
                <div className="font-normal text-[13px] text-[#6B7280]">
                  {data?.email || "No Device found"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" flex flex-column gap-0 mt-0">
          {" "}
          {renderGraph()}
          {/* Tabs for BPP, WLM, CGM */}
          {/* {data?.BPP?.length > 0 || data?.WLM?.length > 0 ? (
            <Infographtab
              tabs={tabs}
              selectedTab={selectedTab}
              onSelectTab={handleTabSelect}
            />
          ) : null} */}
        </div>
    <div className="flex sm:flex-col gap-4 justify-between lg:mt-0 md:mt-0 sm:mt-0 mt-2">

  {/* EDIT */}
  <div className="relative group h-[56px] w-[56px] bg-[#F9FAFB] flex justify-center items-center rounded-md hover:bg-[#1D2951] hover:text-white"
       onClick={() => { setSelectedCard(data); setEditPatient(true); }}>
    {penIcon}
    <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap z-50">
   Edit Patient
    </span>
  </div>

  {/* ADD NOTE */}
  <div className="relative cursor-pointer group h-[56px] w-[56px] bg-[#F9FAFB] flex justify-center items-center rounded-md hover:bg-[#1D2951] hover:text-white"
       onClick={() => { setSelectedCard(data); setNotesForm(true); }}>
    {fileIcon}
    <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap z-50">
      Add Notes
    </span>
  </div>

  {/* FILTER */}
  <div className="relative group cursor-pointer h-[56px] w-[56px] bg-[#F9FAFB] flex justify-center items-center rounded-md hover:bg-[#1D2951] hover:text-white"
       onClick={() => { setSelectedCard(data); setRiskmodal(true); }}>
    {flagIcon}
    <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap z-50">
      Filter
    </span>
  </div>

  {/* CHAT */}
  <div className="relative cursor-pointer group h-[56px] w-[56px] bg-[#F9FAFB] flex justify-center items-center rounded-md hover:bg-[#1D2951] hover:text-white"
       onClick={handleComment}>
    {chatIcon}
    <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap z-50">
    Message
    </span>
  </div>

</div>

      </div>
    </div>
  );
};

export default InfoCard;
